import { randomRange } from '../functions/randomRange.js';

export function rollInImage(el) {
  el.addEventListener('mouseenter', function() {
    const image = el.querySelector('.roll-in-image');
    if (image) {
      image.style.setProperty('--rotate', randomRange(-10, 10));
    }
  });
}
